/**
 * Reads the Early Access flag from Clerk's active organization metadata.
 *
 * Source of truth is `publicMetadata.earlyAccess`, written by the billing
 * service when a tenant is granted Early Access (gratis Pro features while
 * `SUBSCRIPTIONS_DISABLED=true`). The key is deliberately distinct from
 * `publicMetadata.subscriptionPlan` so EA state never bleeds into the other
 * app that shares the same Clerk org.
 *
 * Returns `false` while the organization is loading so consumers never
 * render the EA UX for an unresolved tenant.
 */

import { useOrganization } from '@clerk/clerk-react'

interface UseOrganizationEarlyAccessReturn {
  isEarlyAccess: boolean
  isLoading: boolean
}

export const useOrganizationEarlyAccess = (): UseOrganizationEarlyAccessReturn => {
  const { organization, isLoaded } = useOrganization()

  if (!isLoaded) {
    return { isEarlyAccess: false, isLoading: true }
  }

  const metadata = organization?.publicMetadata as { earlyAccess?: unknown } | undefined

  return {
    isEarlyAccess: metadata?.earlyAccess === true,
    isLoading: false,
  }
}
